/**
 * Created by zt on 2018/09/29
 */
/* eslint-disable */
import Vue from 'vue';
import store from '@/vuex/index';
import { NativeService } from '@/service/native/nativePluginService';
import { getCardSign, getInvoicePDF } from '@/api/getData.js';
import { dateFormat, getDateStamp, deepClone } from 'utils/indexV2';
import config from 'config';
import { getQueryString, getEnvironmentType, getH5Platform } from '@/utils/environment';
import {
  checkoutInvoice,
  receiptFoldCheckoutInvoice,
  getInvoiceDetail,
  getInvoiceDetailByAlipay,
  getRecommendedInvoiceHistory,
  ocrCheckoutInvoice,
  ofdCheckoutInvoice,
  xmlCheckoutInvoice,
  ocrPXMCheckoutInvoice,
  getReceiptChangeHistoryByInvoice,
  getAliPayAuthority,
  getAliPayAuthorityUrl,
  receiptAutoCreateInvoice,
} from '@/api/expense';
import receiptIconWechat from '@/assets/images/receipt/icon_wechat.png';
import receiptIconAlipay from '@/assets/images/receipt/icon_alipay.png';
import { registerMobstat } from '@/utils/piwik';
import FloatTool from 'utils/floatTool';
import wechatIcon from '@/assets/images/receipt/icon-wechat.png';
import handIcon from '@/assets/images/receipt/icon-hand.png';
import scanIcon from '@/assets/images/receipt/icon-scan.png';
import ocrIcon from '@/assets/images/receipt/icon-ocr.png';
import mailIcon from '@/assets/images/receipt/icon-mail.png';
import didi from '@/assets/images/receipt/icon-didi.png';
import * as InvoiceHandlerV2 from '@/service/invoice/indexV2';
// 多张
let weXinInvoiceDetailDemo = [];
// 1张
// weXinInvoiceDetailDemo = [{
//     "cardId": "pIKi3wZl2Daxlyi1wriZ_s_C3klk",
//     "cardSignType": "APPCARDSIGN",
//     "encryptCode": "O/mPnGTpBu22a1szmK2ogzhFPBh9eYzv2p70L8yzyykBoTdEGnOi8TSuvAUzX8XrVc8waIuX5cfRc3sZ4h0/H2x6fRGKWM1JNk49l3pNq8dMSL54k5tmJE3Zt46lSbgw"
// }];
let invoiceDetailDemo = { success: true, code: '0000', rows: [] };
// 拍照数据图片
let baiwangImageDemo = [];

const mKMaps = {
  // 将新老messageKey转换关系表化为JSON
  'restaurant.location': ['helios.location'],
  location: ['helios.city', 'helios.departure.city', 'helios.destination.city'],
  city: ['helios.city'],
  'departure.location': ['helios.departure.location'],
  'depart.place': ['helios.departure.location'],
  'start.time': ['helios.start.time'],
  'departure.time': ['helios.start.time'],
  'depart.time': ['helios.start.time'],
  'depart.station': ['helios.departure.location'],
  'arrival.time': ['helios.end.time'],
  'end.time': ['helios.end.time'],
  'arrival.station': ['helios.destination.location'],
  'order.currencyCode': ['helios.order.currency'],
  'depart.date': ['helios.start.time'],
  'associate.application': ['helios.associate.application'],
  totalStay: ['helios.days'],
  dateCombined: ['helios.dateCombined'],
  destination: ['helios.destination.location'],
  'destination.location': ['helios.destination.location'],
  'hotel.checkin.date': ['helios.start.time'],
  days: ['helios.days', 'helios.rooms'],
  address: ['helios.location'],
  rooms: ['helios.rooms'],
  'hotel.rooms': ['helios.room.count'],
  'business.type': ['helios.business.type'],
  participants: ['helios.participants'],
  participant: ['helios.participant'],
};

export default {
  timeTemp: 0, // 拍照扫码记录时间挫
  scanTimer: null, // 扫码计时器
  clearScanTimer() {
    if (this.scanTimer) {
      clearInterval(this.scanTimer);
    }
  },
  setTimeTemp(val) {
    this.timeTemp = val;
  },
  // 多语言翻译
  $t(value, data) {
    return Vue.i18n.translate(value, data);
  },
  /**
   * 是否显示ocr
   *    微信 钉钉 app 本地开发
   * @returns {*|boolean|default.isInApp}
   */
  isShowOcrScenario() {
    let platform = getH5Platform();
    return (
      ['wx', 'dd', 'webapp', 'lark', 'welink', 'yzj'].includes(platform) ||
      store.getters.isInApp ||
      ['portal', 'webapp'].includes(config.environment)
    );
  },
  /**
   * 发票入口场景
   * @returns {*[]}
   */
  getInvoiceScenario(receiptSourceOpt = {}) {
    let profile = store.getters.getProfile;
    let platform = getH5Platform();
    let isInApp = store.getters.isInApp || ['portal', 'webapp'].includes(config.environment);
    // 微信
    const isWX = platform === 'wx';
    // 钉钉
    const isDd = platform === 'dd';
    // 飞书
    const isLark = platform === 'lark';
    //weLink
    const isWeLink = platform === 'welink';
    // 云之家
    const isYunZhiJia = platform === 'yzj';
    // isInApp && profile && profile['invoice.ocr.enable']

    const hasOfdAndPdf = () => {
      return (
        (isInApp && Vue.prototype.COMMON.versionEnable('2.14.3')) ||
        ['wx', 'dd', 'lark', 'webapp', 'yzj', 'welink'].indexOf(platform) > -1
      );
    };

    let receiptSourceOption = receiptSourceOpt.levelOrgId
      ? receiptSourceOpt
      : Vue.prototype.COMMON.getOption('receiptSourceOpt');

    return [
      {
        code: 'ocr-invoice',
        buttonIcon: 'IconMediaCamera',
        buttonText: window.$t('expense-2.key395', { cm: '拍发票' }),
        info: window.$t('expense-2.key496', { cm: '智能多图识别' }),
        show: false,
        style: {
          color: '#4988FE',
        },
      },
      // {
      //   code: 'import-image',
      //   buttonIcon: 'image-verify',
      //   buttonText: window.$t('expense-2.key497', { cm: '拍照查验' }),
      //   info: window.$t('expense-2.key498', { cm: '拍照识别并查验' }),
      //   show: isInApp && profile && profile['invoice.check.platform'] === 'ansheng-baiwang',
      // },
      {
        code: 'scan-invoice',
        buttonIcon: 'IconOperateScanCode',
        buttonText: window.$t('expense-2.key499', { cm: '扫发票' }),
        info: window.$t('expense-2.key500', { cm: '扫描发票二维码' }),
        style: { color: '#FFAA47' },
        show:
          receiptSourceOption?.scanningInvoice &&
          this.showInvoiceMenuByOption(store.getters.getOptions, 'webAppQrScan'),
      },
      {
        code: 'weixin',
        buttonIcon: 'IconPartyWechat',
        buttonText: window.$t('expense-2.key501', { cm: '微信发票' }),
        info: window.$t('expense-2.key502', { cm: '从微信导入' }),
        style: { color: '#0CD065' },
        show:
          !isDd &&
          !isLark &&
          !isWeLink &&
          //!isYunZhiJia &&
          receiptSourceOption?.electronicInvoice &&
          this.showInvoiceMenuByOption(store.getters.getOptions, 'webAppWechatInvoice'),
      },
      {
        code: 'Alipay',
        buttonIcon: 'IconPartyAlipay',
        buttonText: window.$t('expense-2.key503', { cm: '支付宝发票' }),
        info: window.$t('expense-2.key504', { cm: '从支付宝导入' }),
        style: { color: '#4988FE' },
        show:
          !isWX &&
          !isDd &&
          !isLark &&
          !isWeLink &&
          !isYunZhiJia &&
          receiptSourceOption.alipayInvoice &&
          this.showInvoiceMenuByOption(store.getters.getOptions, 'webAppAlipayInvoice'),
      },
      {
        code: 'email-import',
        buttonIcon: 'IconTextMail',
        buttonText: window.$t('expense-2.key505', { cm: '发票夹和邮箱发票' }),
        info: window.$t('expense-2.key752', { cm: '从发票夹导入' }),
        style: { color: '#FFAA47' },
        show: false,
      },
      {
        code: 'public-pay-poll',
        buttonIcon: 'IconTextFoader',
        buttonText: window.$t('expense-2.key884', { cm: '企业发票池' }),
        info: window.$t('expense-2.key885', { cm: '从企业发票池导入' }),
        show: false,
        style: {
          color: '#4988FE',
        },
      },
      {
        code: 'entering-invoice',
        buttonIcon: 'IconOperateEditFile',
        buttonText: window.$t('expense-2.key506', { cm: '手录发票' }),
        info: window.$t('expense-2.key507', { cm: '手动填写发票' }),
        style: { color: '#FFAA47' },
        show: receiptSourceOption.handInvoice && receiptSourceOption.handAllowRole === 'all',
      },
      {
        code: 'ofd-invoice',
        buttonIcon: 'IconTextOfd',
        buttonText: window.$t('expense-2.key508', { cm: '识别OFD' }),
        info: window.$t('expense-2.key509', { cm: '上传发票OFD' }),
        style: { color: '#FC7474' },
        show: hasOfdAndPdf() && receiptSourceOption.ofdInvoice,
      },
      {
        code: 'pdf-invoice',
        buttonIcon: 'IconTextPdf',
        buttonText: window.$t('expense-2.key610', { cm: '识别PDF' }),
        info: window.$t('expense-2.key611', { cm: '上传发票PDF' }),
        style: { color: '#FC7474' },
        show: hasOfdAndPdf(),
      },
      {
        code: 'xml-invoice',
        buttonIcon: 'IconTextXml',
        buttonText: window.$t('expense-2.key767', { cm: '识别XML' }),
        info: window.$t('expense-2.key768', { cm: '上传发票XML' }),
        show: hasOfdAndPdf() && receiptSourceOption.xmlInvoice,
        style: {
          color: '#4988FE',
        },
      },
      {
        code: 'xml-zip',
        buttonIcon: 'IconTextZip',
        buttonText: window.$t('expense-2.key941', { cm: '识别zip压缩包' }),
        info: window.$t('expense-2.key942', { cm: '仅包含一个XML文件' }),
        show: hasOfdAndPdf() && receiptSourceOption.xmlZip,
        style: {
          color: '#4988FE',
        },
      },
      {
        code: 'foreign-receipts',
        buttonIcon: 'IconFinanceTicket',
        buttonText: window.$t('expense-2.key578', { cm: '国际小票' }),
        info: window.$t('expense-2.key579', { cm: '识别国际小票' }),
        show: false,
        style: {
          color: '#4988FE',
        },
      },
    ];
  },
  /**
   * 创建promsie 对象
   * @param fn
   * @returns {Promise}
   */
  createdPromise(fn, ...params) {
    return new Promise((resolve, reject) => {
      fn(resolve, reject, ...params);
    });
  },
  // 支付宝导入发票处理
  alipayInvoice(userOID) {
    return this.createdPromise(this.alipayInvoiceHandle, userOID);
  },
  alipayInvoiceHandle(resolve, reject, userOID) {
    //暂时处理实验阶段
    let destUrl = encodeURIComponent(
      'https://dingtalkstage.huilianyi.com/huilianyi/wechat/?loginType=wx&loginName=13322222266&pwd=hly123&state=STATE'
    );
    // let destUrl1 = encodeURIComponent('https://apiuat.huilianyi.com/alijump.html?source=dingtalk');
    // let destUrl2 = encodeURIComponent('dingtalk://dingtalkclient/page/link?url=' + destUrl);
    let dingtalkUrl = encodeURIComponent('dingtalk://dingtalkclient/page/link?url=' + destUrl);
    let alipayUrl = encodeURIComponent(
      '/www/invoiceSelect.htm?scene=INVOICE_EXPENSE&einvMerchantId=91310118MA1JLFER1F&serverRedirectUrl=' + dingtalkUrl
    );
    let url = 'https://render.alipay.com/p/s/i?appId=20000920&startMultApp=YES&url=' + alipayUrl;

    // 放开限制，webapp也可以使用
    if (1 === 1) {
      url =
        'https://render.alipay.com/p/s/i?appId=20000920&startMultApp=YES&' +
        'url=%2Fwww%2FinvoiceSelect.htm%3Fscene%3DINVOICE_EXPENSE%26einvMerchantId%3D91310118MA1JLFER1F' +
        '%26serverRedirectUrl%3D' +
        'huilianyiapp' +
        '%253A%252F%252Fstartapp%253Fsource%253Dapp%2526type%253Dinvoice';
      let pro = Promise.resolve(1);
      if (store.getters.isInApp && Vue.prototype.COMMON.versionEnable('2.11.0')) {
        Vue.prototype.$plugins.showLoading({ type: 'LOADING' });
        // 权限处理需要最新版app
        pro = new Promise((resolve) => {
          Promise.all([
            getAliPayAuthority(userOID),
            getAliPayAuthorityUrl({ scene: 'invoice', scope: 'auth_invoice_per' }),
          ])
            .then((res) => {
              if (res[0].data.rows) {
                url = `alipays://platformapi/startapp?appId=20000067&url=${encodeURIComponent(res[1].data.rows.url)}`;
              }
              Vue.prototype.$plugins.hideLoading();
              resolve(1);
            })
            .catch(() => {
              Vue.prototype.$plugins.hideLoading();
              resolve(1);
            });
        });
      }
      pro.finally(() => {
        NativeService().chooseAliPayInvoice(
          url,
          (res1) => {
            let aliPayRes = JSON.parse(res1);
            /** @namespace aliPayRes.data.antinvoiceToken */
            if (aliPayRes.data && aliPayRes.data.antinvoiceToken) {
              // Vue.prototype.$plugins.showLoading({ type: 'LOADING' });
              Vue.prototype.$plugins.message.loading({
                title: window.$t('expense-2.key848', { cm: '正在导入发票' }),
                closeEnable: true,
                clearUrl: ['/receipt/api/receipt/alipay/details', '/receipt/api/receipt/verify/batch'],
                description: window.$t('expense-2.key847', { cm: '过程中请勿离开该页面' }),
              });
              getInvoiceDetailByAlipay(aliPayRes.data.antinvoiceToken).then(
                (res2) => {
                  if (res2.data.rows && res2.data.rows.length > 0) {
                    let invoices = res2.data.rows;
                    resolve(invoices);
                  } else {
                    reject();
                  }
                },
                (err) => {
                  reject(err);
                }
              );
            }
          },
          (err) => {
            reject(err);
          }
        );
      });
    } else {
      if (invoiceDetailDemo.rows && invoiceDetailDemo.rows.length > 0) {
        let invoices = invoiceDetailDemo.rows;
        resolve(invoices);
      }
    }
  },
  // 微信导入发票处理
  wxInvoice() {
    return this.createdPromise(this.wxInvoiceImportHandle);
  },
  wxInvoiceImportHandle(resolve, reject) {
    if (config.environment !== 'portal') {
      let cardSignType = 'JSCARDSIGN';
      if (store.getters.isInApp) {
        cardSignType = 'APPCARDSIGN';
      }
      if (getEnvironmentType('loginType') === 'wxmp') {
        cardSignType = 'WXFWCARDSIGN';
      }

      /*let res = {
        returnCode: 'OK',
        info: [{
          "cardSignType": "APPCARDSIGN",
          "cardId": "pIKi3waH_YO8Q1TwGozX-eshuz2E",
          "encryptCode": "O\/mPnGTpBu22a1szmK2ogzhFPBh9eYzv2p70L8yzyykBoTdEGnOi8TSuvAUzX8XraJ5x9XlCn2Bo+pxpG1QO2fhRbFVUz6\/K\/oL\/Gh8ZsolVpgKQj5DNU4uwdtSCuR0l"
        }, {
          "cardSignType": "APPCARDSIGN",
          "cardId": "poCkDj-uCC0_BsEgQHFDlTYomlVo",
          "encryptCode": "O\/mPnGTpBu22a1szmK2ogzhFPBh9eYzv2p70L8yzyylVJmOh1aeTQUPUE4tH\/mzR6Dk28U7LIJjH4l0JxZis+2a9b13Z85ly1zFMj+uQAY1VpgKQj5DNU4uwdtSCuR0l"
        }, {
          "cardSignType": "APPCARDSIGN",
          "cardId": "pIKi3wZl2Daxlyi1wriZ_s_C3klk",
          "encryptCode": "O\/mPnGTpBu22a1szmK2ogzhFPBh9eYzv2p70L8yzyykBoTdEGnOi8TSuvAUzX8Xr6RFLn5+O1XU+tBJlmc5h9KbJN\/MEOgSefdAna0Ay5yBVpgKQj5DNU4uwdtSCuR0l"
        }]
      };
      resolve(res.info)
      return;*/

      getCardSign(cardSignType)
        .then((response) => {
          NativeService().chooseInvoice(
            (res) => {
              if (res.returnCode === 'OK') {
                resolve(res.info);
              }
            },
            (err) => {
              reject(err);
            },
            response
          );
        })
        .catch((err) => {
          reject(err);
        });
    } else {
      resolve(weXinInvoiceDetailDemo);
    }
  },
  // 扫码发票处理
  scanInvoice() {
    let scanInvoiceHandle = (resolve, reject) => {
      if (['webapp', 'portal'].includes(config.environment)) {
        let code;
        // code = '01,01,3100162130,79470882,3584.91,20170628,,FA6E,';
        // code = '01,01,6100164160,00007035,4700.00,20170328,,CF40,';
        code = '01,10,050002100211,67314373,139.82,20220503,78793201061495644143,A097,';
        // code = '01,14,037001700112,27468605,4000.00,20180429,504011,,';
        // code = '01,10,061001801211,76215648,28.36,20181130,77589372511177961282,A960,';
        // code = '01,10,061001701111,00462153,50.42,20170825,43747511703116953102,CBC0'; //bug25910
        //code = "01,03,161001722600,00136078,60940.17,20170729,3956,";//机销发票
        //code = "01,10,011001605111,71139160,65.0,20160913,57372408353471202939" //
        //code = "02,04,3100173320,05953492,,20180811,601148,9999,";
        // code = "https://u.wechat.com/MK6BVPDTOvVupFpGVnHw-d0"\
        resolve({ qrCode: [{ code }] });
        return !1;
      } else {
        try {
          this.clearScanTimer();
          this.scanTimer = setInterval(() => {
            registerMobstat('ocr_invoice', '识别失败');
          }, 5000);
          NativeService().scan(
            (res) => {
              let code = res.resultStr || res.text;
              this.clearScanTimer();
              try {
                if (res.type !== 'INPUT') {
                  registerMobstat('ocr_invoice', '识别成功');
                }
              } catch (e) {}
              resolve({ type: res.type, qrCode: [{ code }] });
            },
            (err) => {
              this.clearScanTimer();
              reject(err);
            },
            {
              isShowEdit: true,
              title: window.$t('expense-2.key499', { cm: '扫发票' }),
              description: window.$t('expense-2.key656', { cm: '请对准发票二维码进行扫描' }),
            }
          );
        } catch (e) {
          reject();
        }
      }
    };
    return this.createdPromise(scanInvoiceHandle);
  },
  // 拍照或者选择照片
  chooseImages(action, length = 1, pending, type) {
    let fn = (resolve, reject) => {
      NativeService().getLocalImgData(
        (res) => {
          // 微信钉钉需要上传图片
          let isPrivate = getQueryString('isPrivate');
          let platform = getH5Platform();
          //welink处理图片上传 识别pdf,ofd统一使用input，不接桥接
          //issue-120362 【交付-鹏新旭】welink单点跳转手机端，拍发票功能无法直接打开摄像头；没有识别pdf入口
          if (platform === 'welink' && action.key !== 'getFile') {
            Promise.all(
              res.map((path) => {
                return new Promise((success, fail) => {
                  NativeService().uploadWeLink(
                    path,
                    (result) => {
                      let { attachmentOID, fileURL, fileName } = result;
                      let obj = { attachmentOID, fileURL, fileName, fileType: 'IMAGE' };
                      success(obj);
                    },
                    (error) => {
                      fail(error);
                    },
                    'INVOICE_IMAGES',
                    true
                  );
                });
              })
            )
              .then((result) => {
                resolve(result);
              })
              .catch((err) => {
                resolve(err);
              });
            //除了 app，识别ofd统一使用input，不接桥接
          } else if (['wx', 'dd'].includes(platform) && !isPrivate && action.key !== 'getFile') {
            pending && pending();
            this.uploadImage(res)
              .then((result) => {
                resolve(result);
              })
              .catch((err) => {
                reject(err);
              });
          } else {
            resolve(res);
          }
        },
        (err) => {
          reject(err);
        },
        length,
        type,
        action,
        pending,
        undefined,
        { upload: false },
        ['ofd', 'pdf', 'xml', 'zip'].includes(type) ? type : undefined
      );
    };
    if (config.environment === 'portal') {
      fn = (resolve) => {
        resolve(baiwangImageDemo);
      };
    }
    return this.createdPromise(fn);
  },
  // 微信钉钉需要h5上传图片
  uploadImage(list) {
    let fn = (resolve, reject) => {
      let params = {
        attachmentType: 'INVOICE_IMAGES',
        companyOID: store.getters.getMyInfo.companyOID,
        corpId: getQueryString('corpId'),
        suiteId: getQueryString('suiteId'),
        userOID: store.getters.getMyInfo.userOID,
        needUploadImg: list,
        successCount: 0,
        isPublic: true,
      };
      NativeService().uploadImage(
        params,
        (successImgList) => {
          resolve(successImgList);
        },
        (successImgList, e) => {
          let errMsg;
          if (Array.isArray(successImgList)) {
            // 微信逐张上传，所以存在部分图片上传成功情况
            errMsg = e.errMsg || e.status || '';
            this.$handPlugin.toast.show(
              window.$t('expense-2.key510', { arg1: successImgList.length + 1, cm: '第{arg1}张图片上传失败' }) +
                ': ' +
                errMsg
            );
          } else {
            // 此时successImgList为返回的异常信息
            errMsg = successImgList.name ? successImgList.name + ':' + successImgList.message : '';
            this.$handPlugin.toast.show(errMsg);
            this.showLoading = false;
          }
          reject();
        },
        []
      );
    };
    return this.createdPromise(fn);
  },
  // 识别
  ocrPXMCheckoutInvoice(params, flag, currentCode) {
    let fn = (resolve, reject) => {
      let timeTemp = new Date().getTime();
      this.timeTemp = timeTemp;
      let method = ocrPXMCheckoutInvoice;
      currentCode === 'ofd-invoice' && (method = ofdCheckoutInvoice);
      ['xml-invoice', 'xml-zip'].includes(currentCode) && (method = xmlCheckoutInvoice);
      method(params, flag)
        .then((result) => {
          if (this.timeTemp === timeTemp) {
            try {
            } catch (e) {}
            resolve(result);
          }
        })
        .catch((err) => {
          if (this.timeTemp === timeTemp) {
            reject(err);
          }
        });
    };
    return this.createdPromise(fn);
  },
  // 拍照查验
  ocrCheckoutInvoice(params) {
    let fn = (resolve, reject) => {
      let timeTemp = new Date().getTime();
      this.timeTemp = timeTemp;
      ocrCheckoutInvoice(params)
        .then((result) => {
          if (this.timeTemp === timeTemp) {
            result.data = [result.data];
            resolve(result);
          }
        })
        .catch((err) => {
          if (this.timeTemp === timeTemp) {
            reject(err);
          }
        });
    };
    return this.createdPromise(fn);
  },
  /**
   * 查验后发票信息前端显示处理
   * @param res
   * @returns {Array}
   */
  invoiceDetailDataHandle(res) {
    return InvoiceHandlerV2.invoiceDetailDataHandle(res);
  },
  checkResultDataHandle(item) {
    return InvoiceHandlerV2.checkResultDataHandle(item);
  },
  getReceiptList(errorList, tipList = []) {
    return InvoiceHandlerV2.getReceiptList(errorList, tipList);
  },
  handleGroupReceipt(res, origin) {
    return {
      ...res,
      ...this.checkResultDataHandle(origin),
    };
  },
  /**
   * 信息是否完整
   * @returns {boolean}
   */
  isCompleteInvoice(resultCode) {
    return InvoiceHandlerV2.isCompleteInvoice(resultCode);
  },
  /**
   * 发票能否打印
   * 打印按钮显示条件:
   * 发票有pdfurl且未损坏
   * @param freePrint 免贴票
   * @param invoice 发票信息
   * @returns {boolean|*|string}
   */
  printAble(freePrint, invoice) {
    if (!invoice) {
      return false;
    }
    /** @namespace invoice.pdfDamaged */
    const canPdf = !invoice.pdfDamaged && invoice.pdfUrl;
    const canVat =
      invoice.receiptType &&
      invoice.receiptType.vat &&
      ['IMAGE'].includes(invoice.originAttachment && invoice.originAttachment.fileType);
    return !freePrint && (canPdf || canVat);
  },
  /**
   * 微信发票查验
   * @param params
   * @returns {Promise}
   */
  wxInvoiceHandle(params) {
    let data = params.map((item) => {
      return item.invoiceInfo;
    });
    return getInvoiceDetail(data);
  },
  /**
   * 发票查验及前端数据转化处理
   * @param params
   * @param userOID
   * @param companyOID
   * @param judgeReceiptFold
   * @returns {Promise}
   */
  checkoutInvoiceHandle(params, userOID, companyOID = undefined, judgeReceiptFold = false) {
    let sourceExpenseClaimInfo = store.getters['expense/detail/sourceExpenseClaimInfo'];
    params.forEach((item) => {
      item.userOID = userOID;
      item.companyOID = companyOID;
    });
    if (sourceExpenseClaimInfo) {
      params.forEach((item) => {
        item.expenseReportOID = sourceExpenseClaimInfo.expenseReportOID;
      });
    }
    return judgeReceiptFold ? receiptFoldCheckoutInvoice(params) : checkoutInvoice(params);
  },
  /**
   * 发票详情路由对象
   * @param source 来源
   * @param invoiceType 类型
   * @param formOID 表单id
   * @param applicationOID 申请人id
   * @returns {
   *     {
   *          name: string,
   *          params: {
   *              pageSource: *,
   *              invoiceType: *
   *          },
   *          query: {
   *              formOID: *,
   *              applicationOID: *
   *          }
   *     }
   * }
   */
  detailRouterOption({ source, invoiceType = 'scan', formOID, applicationOID, isCorpBusiness, ownerId, pageFrom }) {
    return InvoiceHandlerV2.detailRouterOption({
      source,
      invoiceType,
      formOID,
      applicationOID,
      isCorpBusiness,
      ownerId,
      pageFrom,
    });
  },
  /**
   * 自动生成费用
   * @param receiptList
   *
   */
  async autoCreatedInvoice(receiptList, sourceExpenseClaimData, merge = false) {
    let result = receiptList;
    let createdList = [];
    if (Vue.prototype.COMMON.getOption('invoiceConfigOpt.autoCreateExpense')) {
      Vue.prototype.$plugins.showLoading({
        text: window.$t('expense-2.key511', { cm: '生成费用中' }),
      });
      try {
        const res = await receiptAutoCreateInvoice({
          receiptList: receiptList,
          ownerOID: sourceExpenseClaimData.userOID,
          expenseReportOID: sourceExpenseClaimData.expenseReportOID,
          merge,
        });
        result = Vue.prototype.COMMON.getValue(res.data, 'toCreateList');
        createdList = Vue.prototype.COMMON.getValue(res.data, 'createdList');
        if (createdList.length > 0) {
          store.commit('expense/list/setExpenseListRefreshFlag', true);
          store.commit('expense-claim/setNeedRefresh', true);
          Vue.$handPlugin.toast.show({
            text: window.$t('expense-2.key512', { arg1: createdList.length, cm: '已自动生成{arg1}笔费用' }),
          });
        }
      } catch (e) {}
      Vue.prototype.$plugins.hideLoading();
    }
    return {
      toCreateList: result,
      createdList,
    };
  },
  /**
   * 发票生成费用路由对象信息
   * @param invoiceInfo 发票信息
   * @param type 费用类型
   * @param recommendationAndHistory 推荐费用类型
   * @returns {
   *      {
   *          name: string,
   *          params: {
   *              mode: string,
   *              invoiceDetail: {
   *                  type: *,
   *                  amount: number|*,
   *                  invoiceInfo: *,
   *                  resultCode: *
   *             },
   *             recommendationAndHistory: *
   *         }
   *      }
   * }
   */
  expenseRouterOption({ invoiceInfo, type, recommendationAndHistory, ownerId = '', isCorpBusiness, source, pageFrom }) {
    let amount = 0;
    invoiceInfo.forEach((item) => {
      amount += +(item.invoicedReceiptAmount || item.unUsedAmount);
    });
    return {
      name: 'expense-create',
      params: {
        mode: 'create',
        invoiceDetail: {
          type: type,
          amount: amount,
          invoiceInfo: invoiceInfo,
        },
        recommendationAndHistory: recommendationAndHistory,
      },
      query: {
        isCorpBusiness,
        ownerId,
        source,
        pageFrom,
      },
    };
  },
  /**
   * 发票时间显示处理
   * @param billingTime
   * @param format
   * @returns {string}
   */
  invoiceShowDate(billingTime, format = 'yyyy-MM-dd') {
    if (billingTime > 0) {
      return dateFormat((billingTime + (new Date().getTimezoneOffset() + 8 * 60) * 60) * 1000, format);
    } else {
      return '';
    }
  },
  /**
   * 金额显示
   * @param val
   * @param currency
   * @returns {string}
   */
  invoicePriceShowHandle(val, currency = 'CNY') {
    if (!val && val !== 0) {
      return '-';
    } else if (isNaN(val)) {
      return val;
    } else {
      return Vue.prototype.COMMON.displayAmount(val / 100, currency);
    }
  },
  // 打开链接
  openLink(url) {
    try {
      NativeService().openLink(
        () => {},
        (err) => {},
        url
      );
    } catch (e) {
      let childWin = window.open(url, '_system');
      if (!childWin) {
        let domA = document.createElement('A');
        domA.href = url;
        domA.target = '_self';
        domA.download = 'report';
        document.body.appendChild(domA);

        domA.click();
        document.body.removeChild(domA);
      }
    }
  },
  // 发票打印, url: 打印地址 url可能过期 所以打印的时候需要每次去拿,id: 发票id
  print(url, id) {
    if (!url && !id) {
      Vue.$handPlugin.toast.show('该发票没有pdf附件');
      return !1;
    }
    if (url && !id) {
      this.openLink(url);
      return !1;
    }
    getInvoicePDF(id).then((res) => {
      let pdfUrl = res.data && res.data.rows && res.data.rows.fileURL;
      if (pdfUrl) {
        this.openLink(pdfUrl);
      } else {
        // 该发票没有pdf附件
        Vue.$handPlugin.toast.show('该发票没有pdf附件');
      }
    });
  },
  /**
   * 取消导入标题文案
   * @param invoice
   * @returns {*}
   */
  getCancelImportTitle(invoice) {
    let result = window.$t('expense-2.key513', { cm: '是否跳过当前发票' });
    if (!invoice) {
      return result;
    }
    switch (invoice.cardsignType) {
      case 'ALICARDSIGN':
        result = window.$t('expense-2.key514', { cm: '跳过后，该发票将会到支付宝卡包' });
        break;
      case 'APPCARDSIGN':
      case 'JSCARDSIGN':
      case 'WXFWCARDSIGN':
        result = window.$t('expense-2.key515', { cm: '跳过后，该发票将会到微信卡包' });
        break;
      default:
        result = window.$t('expense-2.key513', { cm: '是否跳过当前发票' });
        break;
    }
    return result;
  },
  /**
   * 删除提示文案
   * @param invoice
   * @returns {*}
   */
  getDeleteInvoiceTip(invoice) {
    let result = window.$t('expense-2.key516', { cm: '确认删除?' });
    if (!invoice) {
      return result;
    }
    switch (invoice.cardsignType) {
      case 'ALICARDSIGN':
        result = window.$t('expense-2.key517', { cm: '删除后，此发票将会退回支付宝' });
        break;
      case 'APPCARDSIGN':
      case 'JSCARDSIGN':
      case 'WXFWCARDSIGN':
        result = window.$t('expense-2.key518', { cm: '删除后，此发票将会退回微信' });
        break;
      default:
        result = window.$t('expense-2.key516', { cm: '确认删除?' });
        break;
    }
    return result;
  },
  /**
   * 获取推荐及历史费用类型
   * @param customFormOID
   * @param invoiceGoods
   * @param applicationOID
   * @param multipleInvoiceSupported
   * @returns {*|Promise}
   */
  getRecommendedInvoiceHistory({
    customFormOID,
    receipts,
    applicationOID,
    multipleInvoiceSupported = null,
    applicantOID,
    companyOID,
  }) {
    const fn = (resolve, reject) => {
      /** @namespace item.taxCode */
      if (receipts.length < 1 || receipts.some((receipt) => !receipt.invoiceTypeNo)) {
        reject();
        return !1;
      }
      let configResults = [];
      receipts = receipts.map((receipt) => {
        let { invoiceGoods = [] } = receipt;
        let taxCodes = invoiceGoods.filter((item) => item.taxCode).map((item) => item.taxCode);
        receipt.configResultDTO && configResults.push(receipt.configResultDTO);
        return {
          receiptTypeNo: receipt.invoiceTypeNo,
          taxCodes: taxCodes,
        };
      });
      getRecommendedInvoiceHistory({
        customFormOID,
        receipts,
        applicationOID,
        withReceipt: 'Y',
        createManually: true,
        multipleInvoiceSupported,
        applicantOID,
        configResults,
        companyOID,
      })
        .then((res) => {
          const data = res.data;
          const recommendedTypes = [];
          data.forEach((item) => {
            /** @namespace item.recommendType: string */
            if (item.recommendType && item.recommendType === 'R') {
              item.showRecommended = true;
              recommendedTypes.push(item);
            }
          });
          resolve({
            recommendedTypes,
            recommendationAndHistory: data,
          });
        })
        .catch((err) => {
          reject(err);
        });
    };
    return this.createdPromise(fn);
  },
  // 获取发票的税率信息
  getTaxRate(digitalInvoice) {
    let taxRate = null;
    if (digitalInvoice.invoiceGoods && Array.isArray(digitalInvoice.invoiceGoods)) {
      for (let i = 0; i < digitalInvoice.invoiceGoods.length; i++) {
        if (digitalInvoice.invoiceGoods[i].taxRate) {
          taxRate = FloatTool.divide(digitalInvoice.invoiceGoods[i].taxRate, 100);
          if (isNaN(taxRate)) {
            taxRate = 0;
          }
          if (taxRate) {
            break;
          }
        }
      }
    }
    if (digitalInvoice.taxRate || digitalInvoice.taxRate === 0) {
      taxRate = digitalInvoice.taxRate;
    }
    return taxRate;
  },
  /**
   * 去除已经存在的发票
   *
   *  发票是否存在 发票一样
   *  发票存在id 且id一样
   *  机票行程单单独验证号码、其他均需要代码号码均有值才验证
   * @param invoice 待验证处理的列表
   * @param receiptList 已经存在的列表
   * @returns {*}
   */
  getValidInvoice(invoice, receiptList) {
    const currentReceiptList = JSON.parse(JSON.stringify(receiptList));
    return invoice
      .sort((a, b) => {
        console.log(a, b);
        let pre = (a.moreInfo || '').includes('抵扣联') ? -1 : 0;
        let next = (b.moreInfo || '').includes('抵扣联') ? -1 : 0;
        return next - pre;
      })
      .filter((item) => {
        const isExit = currentReceiptList.some((receipt) => {
          return (
            (item.invoiceTypeNo === receipt.invoiceTypeNo &&
              item.billingNo === receipt.billingNo &&
              item.fee === receipt.fee &&
              item.billingNo &&
              item.billingCode === receipt.billingCode &&
              (item.billingCode || this.isAirTicket(item.invoiceTypeNo))) ||
            (item.id && item.id === receipt.id)
          );
        });
        // 不存在则将改发票添加到存在的列表中 防止待处理的列表中存在一样的数据
        if (!isExit) {
          currentReceiptList.push(item);
        }
        return !isExit;
      });
  },
  /**
   * 发票重复验证
   * @param invoices
   * @param receiptList
   * @returns {{message: string, validInvoice: Array}}
   */
  validInvoicesRepeat(invoices, receiptList) {
    let result = {
      message: '',
      validInvoice: [],
    };
    let validInvoice = this.getValidInvoice(invoices, receiptList);
    result.validInvoice = validInvoice;
    if (validInvoice.length === 0) {
      if (invoices.length === 1) {
        result.message = window.$t('expense-2.key592', { cm: '该费用下当前发票已存在，请勿重复添加' });
      } else {
        result.message = window.$t('expense-2.key742', { arg1: invoices.length, cm: '删除重复录入发票{arg1}张' });
      }
    } else {
      if (invoices.length !== validInvoice.length) {
        result.message = window.$t('expense-2.key742', {
          arg1: invoices.length - validInvoice.length,
          cm: '删除重复录入发票{arg1}张',
        });
      }
    }
    return result;
  },
  /**
   * 可抵扣票验证
   * @param invoices
   * @param validTax
   * @param receiptList
   * @returns {{errorFlag: boolean, message: string}}
   */

  validVatSpecial(invoices, validTax, receiptList) {
    // 可抵扣票
    let result = {
      errorFlag: false,
      message: window.$t('expense-2.key522', { cm: '“可抵扣”与“不可抵扣”的发票不能并存，请调整' }),
    };
    let currentInvoice;
    if (receiptList.length > 0) {
      currentInvoice = receiptList[0];
    } else {
      currentInvoice = invoices[0];
    }
    // 发票税率处理
    let taxRate = this.getTaxRate(currentInvoice);
    // 已经存在的发票是否为可抵扣票
    let isVatType = currentInvoice ? currentInvoice.vatInvoice : false;
    // 待查验的发票过滤可抵扣票
    let vatInvoices = invoices.filter((item) => {
      return item.vatInvoice;
    });
    // 错误处理
    // 1: 没有可抵扣票且已存在不可抵扣票 或者部分为可抵扣票
    // 2: 都为可抵扣票 1): 已存在不可抵扣票 2)：税率不一致
    if ((vatInvoices.length === 0 && isVatType) || (vatInvoices.length > 0 && vatInvoices.length !== invoices.length)) {
      result.errorFlag = true;
    } else if (vatInvoices.length > 0 && vatInvoices.length === invoices.length) {
      // 都为可抵扣票
      // 1: 已存在不可抵扣票
      if (!isVatType && currentInvoice) {
        result.errorFlag = true;
      } else {
        if (validTax) {
          // 税率不一致
          let notConsistentTaxRate = vatInvoices.some((invoice) => {
            return this.getTaxRate(invoice) !== taxRate;
          });
          if (notConsistentTaxRate) {
            result.errorFlag = true;
            result.message = window.$t('expense-2.key523', { cm: '税率不同的“可抵扣”发票不能并存，请调整' });
          }
        }
      }
    }
    return result;
  },
  // 发票固定扩展字段
  getExtendedField(typeNo) {
    return [
      this.setField('remark', window.$t('common.key74', { cm: '备注' })),
      this.setField('payee', window.$t('expense-2.key379', { cm: '销售方名称' })),
      this.setField('payeeNo', window.$t('expense-2.key524', { cm: '销售方纳税人识别号' })),
      this.setField('payeeAddressPhone', window.$t('expense-2.key661', { cm: '销售方地址、电话' })),
      this.setField('payeeBankAccount', window.$t('expense-2.key662', { cm: '销售方开户行及账号' })),
      this.setField('title', window.$t('expense-2.key525', { cm: '购买方名称' })),
      this.setField('draweeNo', window.$t('expense-2.key526', { cm: '购买方纳税人识别号' })),
      this.setField('draweeAddressPhone', window.$t('expense-2.key663', { cm: '购买方地址、电话' })),
      this.setField('draweeBankAccount', window.$t('expense-2.key664', { cm: '购买方开户行及账号' })),
      this.setField('allElectricalBillingNo', window.$t('expense-2.key928', { cm: '数电发票号码' })),
    ].filter((c) => {
      // 国际小票销方名称，税号为固定字段
      if (typeNo === '777') return !['payee', 'payeeNo'].includes(c.key);
      return true;
    });
  },
  setField(key, label) {
    return { key, label };
  },
  // 发票类型特殊扩展字段
  getMoreExtendedField(invoiceMoreInfo = '{}', moreInfoLabel = '{}') {
    let fieldMap = JSON.parse(moreInfoLabel || '{}');
    const moreInfo = invoiceMoreInfo || '{}';
    return Object.keys(JSON.parse(moreInfo))
      .map((item) => {
        return fieldMap[item] ? this.setField(item, fieldMap[item]) : false;
      })
      .filter((field) => field);
  },
  /**
   * 发票转发票控件数据格式
   * @param digitalInvoice
   * @returns {*}
   */
  getVatInvoice(digitalInvoice) {
    if (!digitalInvoice.type && !['OCR', 'MAIL'].includes(digitalInvoice.cardsignType)) {
      return {};
    }
    let invoiceDate = null;
    if (digitalInvoice.billingTime) {
      invoiceDate = new Date(
        (digitalInvoice.billingTime + (new Date().getTimezoneOffset() + 8 * 60) * 60) * 1000
      ).Format('yyyy-MM-dd');
    }
    let taxRate = this.getTaxRate(digitalInvoice);
    // 页面显示值需要缩小100倍
    let amountInfo = {
      tax: null, // 税额合计 taxAmount
      feeWithoutTax: null, // 不含税金额 nonVATinclusiveAmount
      fee: null, // 价税合计 priceTaxAmount
      nonDeductibleAmount: null, // 不可抵扣 nonDeductibleAmount
    };
    Object.keys(amountInfo).forEach((key) => {
      if (digitalInvoice[key] || digitalInvoice[key] === 0) {
        amountInfo[key] = FloatTool.divide(digitalInvoice[key], 100);
      }
    });
    let checkCode;
    if (digitalInvoice.checkCode && digitalInvoice.checkCode !== '') {
      checkCode = digitalInvoice.checkCode;
      if (digitalInvoice.checkCode.length > 6) {
        checkCode = digitalInvoice.checkCode.substring(digitalInvoice.checkCode.length - 6);
      }
    }
    let vatInvoiceRes = {
      invoiceType: {
        messageKey: digitalInvoice.type,
        value: digitalInvoice.invoiceTypeNo,
      },
      formOID: digitalInvoice.formOID || ((digitalInvoice.customFormValues || [])[0] || {}).formOID,
      slicingAttachment: digitalInvoice.slicingAttachment,
      receiptLabels: digitalInvoice.receiptLabels || [],
      id: digitalInvoice.id,
      checkCode: checkCode,
      billingTime: digitalInvoice.billingTime,
      invoiceCode: digitalInvoice.billingCode,
      invoiceNumber: digitalInvoice.billingNo,
      invoiceDate: invoiceDate,
      vatInvoiceCurrencyCode: digitalInvoice.vatInvoiceCurrencyCode,
      priceTaxAmount: amountInfo.fee,
      taxRate: taxRate,
      taxAmount: amountInfo.tax,
      nonVATinclusiveAmount: amountInfo.feeWithoutTax,
      cardsignType: digitalInvoice.cardsignType,
      moreInfo: digitalInvoice.moreInfo,
      nonDeductibleAmount: amountInfo.nonDeductibleAmount,
      owner: digitalInvoice.receiptOwner,
      personInfo: digitalInvoice.showUserInfo,
      internal: digitalInvoice.internalStaff,
      isImportVat: digitalInvoice.isImportVat,
      issuedReceipt: digitalInvoice.agentTag,
      domesticPassengers: digitalInvoice.domesticPassengers,
      fromCityCode: digitalInvoice.fromCityCode,
      fromCityName: digitalInvoice.fromCityName,
      toCityCode: digitalInvoice.toCityCode,
      toCityName: digitalInvoice.toCityName,
      idCardNo: digitalInvoice.idCardNo,
      sellerCityCode: digitalInvoice.sellerCityCode,
      sellerCityName: digitalInvoice.sellerCityName,
      image: digitalInvoice.originAttachment
        ? [digitalInvoice.originAttachment]
        : digitalInvoice.slicingAttachment
        ? [digitalInvoice.slicingAttachment]
        : [],
      generateAttachmentOID: digitalInvoice.generateAttachmentOID,
      generateAttach: digitalInvoice.generateAttachment ? [digitalInvoice.generateAttachment] : [],
      invoiceGoods: digitalInvoice.invoiceGoods || [],
      attachmentOID: digitalInvoice.attachmentOID,
      showSellerCity: digitalInvoice.showSellerCity,
    };

    //补充电子票换坏标签
    if (digitalInvoice && digitalInvoice.pdfDamaged === true) {
      vatInvoiceRes.receiptLabels.push({
        id: null,
        type: 'PDF_DAMAGED',
        name: window.$t('expense-2.key308', { cm: '电子票损坏' }),
        level: 'ERROR',
        description: '',
      });
    }

    let extendedField = this.getExtendedField();
    extendedField.forEach((item) => {
      let key = item.key;
      vatInvoiceRes[key] = digitalInvoice[key];
    });
    return vatInvoiceRes;
  },
  /**
   * 手工录入发票处理
   * @param invoice
   * @param invoiceType
   * @param id
   * @param sourceInvoice 原始发票信息
   * @param invoiceGoods
   * @returns {*}
   *
   */
  enteringInvoiceHandle({ invoice, invoiceType, id = '', sourceInvoice, invoiceGoods = [] }) {
    let billingTime = '';
    if (invoice.invoiceDate && invoice.invoiceDate.value) {
      billingTime =
        getDateStamp(dateFormat(invoice.invoiceDate.value, 'yyyy-MM-dd 00:00:00')) / 1000 -
        (new Date().getTimezoneOffset() + 8 * 60) * 60;
    }
    let taxRate = Vue.prototype.COMMON.getValue(invoice, 'taxRate.value.taxRateValue') || '';
    let currency = Vue.prototype.COMMON.getValue(invoice, 'vatInvoiceCurrencyCode.value.currency') || '';
    // 保存时值需要放大100倍
    let amountInfo = {
      taxAmount: null, // 税额合计 tax
      nonVATinclusiveAmount: null, // 不含税金额  feeWithoutTax
      priceTaxAmount: null, // 价税合计 fee
      nonDeductibleAmount: null, // 不可抵扣 nonDeductibleAmount
    };
    Object.keys(amountInfo).forEach((key) => {
      if (invoice[key] && (invoice[key].value || invoice[key].value === 0)) {
        amountInfo[key] = FloatTool.multiply(invoice[key].value, 100);
      }
    });
    // 值列表处理 有值需要取id 否则为空
    let selectedFieldValuesMap = {
      showUserInfo: 'personInfo', // 显示人员信息
      internalStaff: 'internal', // 是否内部人员
      isImportVat: 'isImportVat',
      agentTag: 'issuedReceipt', // 是否代开
      domesticPassengers: 'domesticPassengers', // 是否国内
    };
    Object.keys(selectedFieldValuesMap).forEach((key) => {
      let currentField = invoice[selectedFieldValuesMap[key]];
      selectedFieldValuesMap[key] = Vue.prototype.COMMON.getValue(currentField, 'value.id') || '';
    });
    // 身份证做特殊处理 只显示部分
    let idCardNo = Vue.prototype.COMMON.getValue(invoice, 'idCardNo.value') || '';
    if (idCardNo) {
      idCardNo = idCardNo.replace(/(\w{10})(\w{4})(.*)/, '$1****$3');
    }
    // 转化后对应值
    let attachmentOID = Vue.prototype.COMMON.getValue(invoice, 'image.value.0.attachmentOID');
    let valueMap = {
      billingCode: invoice.invoiceCode && invoice.invoiceCode.value,
      billingNo: invoice.invoiceNumber && invoice.invoiceNumber.value,
      billingTime: billingTime,
      vatInvoiceCurrencyCode: currency,
      taxRate: taxRate,
      tax: amountInfo.taxAmount,
      feeWithoutTax: amountInfo.nonVATinclusiveAmount,
      fee: amountInfo.priceTaxAmount,
      checkCode: invoice.checkCode && invoice.checkCode.value,
      nonDeductibleAmount: amountInfo.nonDeductibleAmount,
      receiptOwner: invoice.owner && invoice.owner.value,
      idCardNo: idCardNo,
      totalAmount: invoice?.receiptTotalAmount?.value,
      // slicingAttachmentOID: attachmentOID,
      attachmentOID: attachmentOID,
      ...selectedFieldValuesMap,
    };
    // 附件处理：如果附件格式为pdf或ofd，则只需要传attachmentOID er-93458
    // if (['PDF', 'OFD'].includes(Vue.prototype.COMMON.getValue(invoice, 'image.value.0.fileType'))) {
    //   valueMap.slicingAttachmentOID = undefined;
    //   valueMap.attachmentOID = attachmentOID;
    // }
    // 扩展字段处理
    let ctrlParams = this.getMapCtrlParams();
    let invoiceInfo = {
      id: id,
      cardsignType: 'HAND',
      type: invoiceType.messageKey,
      invoiceTypeNo: invoiceType.value,
    };
    // 控件显示才复制
    Object.keys(ctrlParams).forEach((key) => {
      if (invoice[ctrlParams[key]] && invoice[ctrlParams[key]].show) {
        if (['fromCityCode', 'toCityCode', 'sellerCityCode'].includes(key)) {
          invoiceInfo[key] = invoice[key].value;
          invoiceInfo[key.replace('Code', 'Name')] = invoice[key].showValue;
        } else {
          invoiceInfo[key] = valueMap[key];
        }
      }
    });
    let extendedField = this.getExtendedField();
    extendedField.forEach((item) => {
      let key = item.key;
      if (invoice[key]) invoiceInfo[key] = invoice[key].value;
    });
    // 部分特殊控件(即发票类型特有字段)需要处理 这块逻辑需要实时维护
    // 如果修改了发票类型 税率/税额/不含税金额/价税合计 配置不显示需要清空值
    if (sourceInvoice && sourceInvoice.invoiceTypeNo !== invoiceInfo.invoiceTypeNo) {
      let specialParams = {
        taxRate: 'taxRate',
        tax: 'taxAmount',
        feeWithoutTax: 'nonVATinclusiveAmount',
        fee: 'priceTaxAmount',
      };
      Object.keys(specialParams).forEach((key) => {
        invoiceInfo[key] = valueMap[key];
      });
    }
    if (typeof invoice.nonDeductibleAmount === 'object' && !invoice.nonDeductibleAmount.show) {
      // 没有不可抵扣的需要清除不可抵扣信息
      invoiceInfo.nonDeductibleAmount = null;
    }
    // 如果存在原始的发票信息 则补充修改的数据查验
    if (sourceInvoice && Object.keys(sourceInvoice).length > 1) {
      let copyInvoice = JSON.parse(JSON.stringify(sourceInvoice));
      invoiceInfo = { ...copyInvoice, ...invoiceInfo };
      // 发票'cardsignType'处理
      if (copyInvoice.cardsignType) {
        invoiceInfo.cardsignType = copyInvoice.cardsignType;
      } else {
        registerMobstat('h5-expense-list-detail', `发票查验cardsignType为空${location.hash}`);
      }
      // 更多扩展字段
      if (invoiceInfo.moreInfo) {
        let invoiceMoreFields = this.getMoreExtendedField(invoiceInfo.moreInfo, sourceInvoice.moreInfoLabel);
        let moreInfo = JSON.parse(invoiceInfo.moreInfo);
        invoiceMoreFields.forEach((item) => {
          let key = item.key;
          if (['formNameVSIO', 'companySealVSIO', 'transitMarkVSIO', 'oilMarkVSIO', 'agent_mark'].includes(key)) {
            moreInfo[key] = invoice[key] && invoice[key].value && invoice[key].value.id;
          } else if (['product_details'].includes(key)) {
            moreInfo[key] = !!(invoice[key] && invoice[key].value === window.$t('expense-2.key210', { cm: '包含' }));
          } else if (['sellerCity'].includes(key)) {
            moreInfo[key] =
              invoice[key] && invoice[key].value
                ? {
                    code: invoice[key].value,
                    name: invoice[key].showValue,
                  }
                : undefined;
          } else {
            moreInfo[key] = invoice[key] && invoice[key].value;
          }
        });
        invoiceInfo.moreInfo = JSON.stringify(moreInfo);
      }
    }
    // 税率精度处理 ios对精度丢失
    if (invoiceInfo.taxRate) {
      invoiceInfo.taxRate = '' + invoiceInfo.taxRate;
    }
    if (invoiceGoods[0] && store.getters.getProfile['invoice.goods.editable.tmp']) {
      invoiceInfo.invoiceGoods = JSON.parse(JSON.stringify(invoiceGoods)).map((item) => {
        let precision = Vue.prototype.COMMON.getAccuracy(currency);
        item.amount = (+(item.amount || 0) * 100).toFixed(precision);
        if (item.taxRate && item.taxRate.value && item.taxRate.value.taxRateValue) {
          item.taxRate = item.taxRate.value.taxRateValue * 100;
          item.taxRateString = item.taxRate + '';
        } else {
          item.taxRateString = '0';
          item.taxRate = 0;
        }
        item.taxPrice = (+(item.taxPrice || 0) * 100).toFixed(precision);
        return item;
      });
    }
    return {
      invoiceInfo: invoiceInfo,
    };
  },
  /**
   * 发票是否查验成功
   * @param digitalInvoice
   * @returns {boolean}
   */
  isCheckSuccessfulInvoice(digitalInvoice) {
    return InvoiceHandlerV2.isCheckSuccessfulInvoice(digitalInvoice);
  },
  /**
   * 是否为电子票(微信 支付宝)
   * @param invoice
   * @returns {*|boolean}
   */
  isETicketValify(invoice) {
    const types = ['ALICARDSIGN', 'APPCARDSIGN', 'JSCARDSIGN', 'WXFWCARDSIGN'];
    return types.includes(invoice.cardsignType);
  },
  /**
   * 可编辑场景
   *       1: 返回值为130102
   *       2: 查验失败
   *       3: 不可生成费用缺少字段
   */
  isEditableInvoice(invoice) {
    return InvoiceHandlerV2.isEditableInvoice(invoice);
  },
  // 是否为机票
  isAirTicket(typeNo) {
    return ['150', 'CZEI113'].includes(typeNo);
  },
  // 需要处理不可抵扣金额
  isNeedNonDeductibleAmount(typeNo) {
    return ['150', '170', '140'].includes(typeNo);
  },
  /**
   * 获取发票可报销金额
   *  机票 小票： 价税合计+不可抵扣
   *  default： 价税合计
   * @param typeNo 发票类型
   * @param fee 发票价税合计
   * @param nonDeductibleAmount 不可抵扣
   * @returns {number}
   */
  getShowPriceTaxAmount({ fee, nonDeductibleAmount }) {
    let result = 0;
    if (!isNaN(+fee)) {
      result = +fee;
    }
    if (!isNaN(+nonDeductibleAmount)) {
      result = FloatTool.add(result, +nonDeductibleAmount);
    }
    return result;
  },
  /**
   * 发票来源说明信息
   */
  invoiceSourceInfoMap() {
    const bussiness = {
      CMBC: Vue.prototype.COMMON.getCurrentLanguageLogoUrl({ sourceUrl: `cmbc-{lan}.png` }),
      ALIPAY: Vue.prototype.COMMON.getCurrentLanguageLogoUrl({ sourceUrl: `alipay-{lan}.png` }),
      HUABEI: Vue.prototype.COMMON.getCurrentLanguageLogoUrl({ sourceUrl: `huabei-{lan}.png` }),
    };
    return {
      ALICARDSIGN: {
        name: window.$t('expense-2.key527', { cm: '支付宝' }),
        icon: receiptIconAlipay,
      },
      HAND: {
        name: window.$t('expense-2.key528', { cm: '手工录入' }),
        icon: handIcon,
      },
      weChatInfo: {
        name: window.$t('expense-2.key529', { cm: '微信' }),
        icon: receiptIconWechat,
      },
      PjjSourceInfo: {
        name: window.$t('expense-2.key530', { cm: '票加加' }),
        icon: '',
      },
      SCANNING: {
        name: window.$t('expense-2.key531', { cm: '扫二维码' }),
        icon: scanIcon,
      },
      OCR: {
        name: window.$t('expense-2.key532', { cm: '拍照识别' }),
        icon: ocrIcon,
      },
      MAIL: {
        name: window.$t('expense-2.key533', { cm: '邮箱导入' }),
        icon: mailIcon,
      },
      APPCARDSIGN: {
        name: window.$t('expense-2.key529', { cm: '微信' }),
        icon: wechatIcon,
      },
      JSCARDSIGN: {
        name: window.$t('expense-2.key529', { cm: '微信' }),
        icon: wechatIcon,
      },
      WXFWCARDSIGN: {
        name: window.$t('expense-2.key529', { cm: '微信' }),
        icon: wechatIcon,
      },
      DIDI: {
        name: '',
        icon: didi,
      },
      CMBC: {
        name: '',
        icon: bussiness.CMBC,
      },
      ALIPAY: {
        name: '',
        icon: bussiness.ALIPAY,
      },
      HUABEI: {
        name: '',
        icon: bussiness.HUABEI,
      },
    };
  },
  getInvoiceSourceInfo(invoice) {
    let key = invoice.cardsignType;
    switch (key) {
      case 'APPCARDSIGN':
      case 'JSCARDSIGN':
        key = 'weChatInfo';
        break;
      case 'PJJCARDSIGN':
      case 'DXCARDSIGN':
      case 'HXCARDSIGN':
        key = 'PjjSourceInfo';
        break;
      default:
        break;
    }
    let infoMap = this.invoiceSourceInfoMap();
    return infoMap[key] || {};
  },
  /**
   * 发票来源说明信息 名称
   * @param invoice
   */
  getInvoiceSourceName(invoice) {
    return `${
      (invoice.cardsignTypeList || [])[0] === 'PUBLIC_PAY' ? window.$t('expense-2.key888', { cm: '企业发票池-' }) : ''
    }${this.getInvoiceSourceInfo(invoice).name}`;
  },
  /**
   * 发票来源说明信息 图标
   */
  getInvoiceSourceIcon(invoice) {
    return this.getInvoiceSourceInfo(invoice).icon;
  },
  /**
   * 需要提示查验返回信息
   * @param invoice 发票详情
   * @returns {boolean}
   */
  isAutoCalculateInvoice(invoice) {
    return InvoiceHandlerV2.isAutoCalculateInvoice(invoice);
  },
  /**
   * 后端参数值对应的前段控件标识 暂时判断是否编辑能处理 后期考虑是否需要优化带入对象的逻辑
   * @returns {{billingCode: string, billingNo: string, billingTime: string, vatInvoiceCurrencyCode: string, taxRate: string, tax: string, feeWithoutTax: string, fee: string, checkCode: string, nonDeductibleAmount: string, receiptOwner: string, slicingAttachmentOID: string}}
   */
  getMapCtrlParams() {
    return {
      billingCode: 'invoiceCode',
      billingNo: 'invoiceNumber',
      billingTime: 'invoiceDate',
      vatInvoiceCurrencyCode: 'vatInvoiceCurrencyCode',
      taxRate: 'taxRate',
      tax: 'taxAmount',
      feeWithoutTax: 'nonVATinclusiveAmount',
      fee: 'priceTaxAmount',
      checkCode: 'checkCode',
      nonDeductibleAmount: 'nonDeductibleAmount',
      receiptOwner: 'owner',
      slicingAttachmentOID: 'image',
      attachmentOID: 'image',
      showUserInfo: 'personInfo',
      internalStaff: 'internal',
      isImportVat: 'isImportVat',
      agentTag: 'issuedReceipt',
      idCardNo: 'idCardNo',
      domesticPassengers: 'domesticPassengers',
      fromCityCode: 'fromCityCode',
      toCityCode: 'toCityCode',
      sellerCityCode: 'sellerCityCode',
      totalAmount: 'receiptTotalAmount',
    };
  },
  getReceiptLabelInfo(invoiceInfo) {
    return new Promise((resolve, reject) => {
      getReceiptChangeHistoryByInvoice(invoiceInfo)
        .then((res) => {
          let receiptLabelList = [];
          if (res.status === 200) {
            receiptLabelList = this.renderLabelContent(res.data);
          }
          resolve(receiptLabelList);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  renderLabelContent(labelList) {
    let list = [];
    if (labelList && labelList.length > 0) {
      labelList.forEach((label) => {
        let tip = {
          class: 'normal',
          title: label.name,
          type: label.type,
          description: label.description,
          tabInfo: [],
        };
        if (label.type === 'PDF_DAMAGED') {
          tip.class = 'error';
        } else if (['UNCLEAR_COMPANY', 'NON_EMPLOYEES', 'INSP_FAILED'].includes(label.type)) {
          tip.class = 'warn';
        } else if (label.type === 'MODIFY_RECEIPT') {
          tip.class = 'warn';
          let history = label.history;
          if (history && history.length > 0) {
            let lines = [];
            history.forEach((his) => {
              let line = {
                title:
                  dateFormat(his.createdDate, 'yyyy-MM-dd hh:mm') + ', ' + his.operatorName + ' ' + his.operatorType,
                distributions: [],
              };
              let detailInfo = his.detailInfo;
              if (detailInfo && detailInfo.length > 0) {
                detailInfo.forEach((detail) => {
                  let temp = window.$t('expense-2.key534', { cm: '空' });
                  let str =
                    detail.property +
                    '：' +
                    window.$t('expense-2.key535', {
                      arg1: detail.oldValue || temp,
                      arg2: detail.newValue || temp,
                      cm: '从 {arg1} 改为 {arg2}',
                    });
                  line.distributions.push(str);
                });
              }
              lines.push(line);
            });
            tip.lines = lines;
          }
        } else if (label.type === 'WRONG_HEADER') {
          tip.class = 'warn';
          try {
            tip.tabInfo = JSON.parse(label.description);
          } catch (e) {}
          tip.description = window.$t('expense-2.key536', { cm: '发票购买方抬头必须在下述范围内' });
        }
        list.push(tip);
      });
    }
    return list;
  },
  shouldCompare(invoiceData = {}) {
    let { receiptLabels = [] } = invoiceData;
    let confirmationNeeded = receiptLabels.filter((item) => item.level === 'ERROR');
    return confirmationNeeded.length === 1 && confirmationNeeded[0].type === '13794@CONFIRMATION_NEEDED';
  },
  mergeInvoiceChange({ currentInvoice, rInvoice, rMoreInfo }) {
    let { receiptLabels: labels, moreInfo } = currentInvoice;
    moreInfo = JSON.parse(moreInfo || '{}');
    labels.splice(
      labels.findIndex((item) => item.code === '13794@CONFIRMATION_NEEDED'),
      1
    );
    moreInfo = Object.assign({}, moreInfo, rMoreInfo);
    currentInvoice.moreInfo = JSON.stringify(moreInfo);
    currentInvoice.isOk = 'Y';
    return Promise.resolve(Object.assign({}, currentInvoice, rInvoice));
  },
  getRelatedApplication(defaultApportion, expenseType) {
    const isApplication = Vue.prototype.COMMON.getValue(defaultApportion, 'applicationApportionmentId');
    const fields = Vue.prototype.COMMON.getValue(expenseType, 'fields') || [];
    const field = fields.find((item) => this.mkClassification(item.messageKey, 'associate.application'));
    const isShowBudgetDetail = Vue.prototype.COMMON.getValue(field, 'config.showBudgetDetail');
    return isApplication && !isShowBudgetDetail;
  },
  // 读取表单配置
  isShowCode(custFormValues, messageKey, costCenterOID) {
    return (
      custFormValues &&
      custFormValues.some((item) => {
        if (!item.fieldConstraint || item.messageKey !== messageKey) return false;
        let fieldConstraint = JSON.parse(item.fieldConstraint);
        if (messageKey === 'select_department') return fieldConstraint.withCode;
        if (messageKey === 'select_cost_center')
          return fieldConstraint.withCode && costCenterOID === JSON.parse(item.dataSource).costCenterOID;
        if (messageKey === 'select_company') return fieldConstraint.isApportionItem;
      })
    );
  },
  getFieldConstraint(custFormValues = [], mk) {
    let fieldConstraint = {};
    custFormValues.some((item) => {
      if (!item.fieldConstraint || item.messageKey !== mk) return false;
      fieldConstraint = JSON.parse(item.fieldConstraint);
    });
    return fieldConstraint;
  },
  old2NewMk(keys) {
    let ret = [];
    if (Array.isArray(keys)) {
      keys.forEach((key) => {
        ret.push(key);
        if (key && key.startsWith('helios')) return;
        let rKeys = deepClone(mKMaps[key]);
        rKeys && ret.push(...rKeys);
      });
    } else if (keys) {
      ret.push(keys);
      if (!keys.startsWith('helios')) {
        let rKeys = deepClone(mKMaps[keys]);
        rKeys && ret.push(...rKeys);
      }
    }
    return Array.from(new Set(ret));
  },
  mkClassification(cur, oldKeys) {
    const keys = this.old2NewMk(oldKeys);
    return keys.includes(cur);
  },
  showInvoiceMenuByOption(options, key) {
    let loginType = getQueryString('loginType');
    if (!loginType || loginType !== 'webapp') {
      return true;
    }
    let thirdPartyOption = options && options.thirdPartyOption;
    let keyValue = thirdPartyOption && thirdPartyOption[key];
    return loginType === 'webapp' && keyValue === false ? false : true;
  },

  // 获取系统计算值与当前值不一致的字段
  getDifferentFields(data = {}, params) {
    const { mySupplementReceipt } = params || {};
    let fieldMap = {
      vatInvoice: 'oldVatInvoice', // 核定可抵扣
      originalApprovedVat: 'oldOriginalApprovedVat', // 核定税额
    };
    // 后补发票不需要触发核定金额
    if (!mySupplementReceipt) fieldMap.amount = 'oldAmount'; // 核定金额
    const differentFields = [];
    Object.keys(fieldMap).forEach((key) => {
      if (data[key] !== data[fieldMap[key]]) {
        if (key === 'originalApprovedVat') {
          data.vatInvoice && differentFields.push(key);
        } else {
          differentFields.push(key);
        }
      }
    });
    return differentFields;
  },
};
